{
  "loading": "جارٍ التحميل...",
  "placeholder": "تحديد…"
}
